var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.792 2.69A3.09 3.09 0 0 0 22.615.513C20.695 0 12.997 0 12.997 0S5.302 0 3.38.513A3.09 3.09 0 0 0 1.202 2.69C.69 4.61.69 8.615.69 8.615s0 4.006.513 5.925a3.09 3.09 0 0 0 2.178 2.177c1.922.513 9.617.513 9.617.513s7.699 0 9.618-.513a3.09 3.09 0 0 0 2.177-2.177c.513-1.919.513-5.925.513-5.925s0-4.006-.513-5.925",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121216",
    fillRule: "evenodd",
    d: "m10.54 12.303 6.394-3.692-6.395-3.693z",
    clipRule: "evenodd"
  })));
};
export default SvgIconYoutube;